import Section from "./Section";
import { useGetExpiringCampaigns } from "../../queries/dashboard";

const ExpiringCampaigns = () => {

    const { data, isPending } = useGetExpiringCampaigns();

    const campaigns = Array.isArray(data) ? data : (data?.campaigns || []);

    return (
        <Section title={"Expiring Campaigns in 7 Days"} isLoading={isPending} gridCols={1} innerPadding={0} theme="purple">
            <div className="bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] p-4 py-2 overflow-y-auto max-h-52">
                {campaigns.length === 0 ? (
                    <div className="py-6 text-center text-gray-500">No expiring campaigns.</div>
                ) : (
                    campaigns.map((c) => (
                        <div key={c._id} className="flex items-center justify-between py-3 border-b border-border">
                            <div className="w-8/12 text-base font-medium">{c.title}</div>
                            <div className="w-4/12 text-right text-sm text-gray-600" data-time={c.endDate}>
                                {c.endDate ? new Intl.DateTimeFormat('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(new Date(c.endDate)) : '—'}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </Section>
    );
}

export default ExpiringCampaigns;